import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X, ZoomIn } from "lucide-react";
import { Section, Eyebrow, Reveal } from "./shared";
import { PROOF, IMAGES } from "../../lib/site";

export default function Proof() {
  const [lightbox, setLightbox] = useState(null);

  return (
    <Section id="proof" bg="bg-brand-palepink">
      <Reveal className="max-w-3xl">
        <Eyebrow color="#E90019">Proof</Eyebrow>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.98] mt-5">
          Don&rsquo;t Just Take My Word for It. Look at the System in Action.
        </h2>
        <p className="text-sm sm:text-base text-brand-ink/70 mt-4 max-w-2xl">
          Real, verified screenshots—earnings, search rankings, evergreen traffic, affiliate payouts, and live lead flow.
        </p>
      </Reveal>

      <div className="grid sm:grid-cols-2 gap-6 sm:gap-8 mt-12">
        {PROOF.map((p, i) => (
          <Reveal key={p.t} delay={(i % 2) * 0.08}>
            <figure
              className="group cursor-pointer rounded-[24px] border-2 border-brand-black bg-white p-3 transition-transform duration-300 hover:-translate-y-1.5 hover:rotate-0"
              style={{ boxShadow: "8px 10px 0 #111111", transform: `rotate(${p.rot}deg)` }}
              onClick={() => setLightbox(IMAGES[p.img])}
              data-testid={`proof-card-${i}`}
            >
              <div className="relative rounded-[16px] overflow-hidden border-2 border-brand-black/10 bg-white">
                <img src={IMAGES[p.img]} alt={p.t} loading="lazy" className={`w-full h-52 sm:h-60 ${p.fit === "contain" ? "object-contain p-2" : "object-cover"}`} />
                <span className="absolute top-3 right-3 h-9 w-9 rounded-full bg-brand-black/70 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <ZoomIn size={16} className="text-white" />
                </span>
              </div>
              <figcaption className="px-2 pt-4 pb-2">
                <h3 className="font-display text-xl">{p.t}</h3>
                <p className="text-sm text-brand-ink/70 mt-1">{p.cap}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <AnimatePresence>
        {lightbox && (
          <motion.div className="fixed inset-0 z-[100] flex items-center justify-center p-6 bg-brand-black/85"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            onClick={() => setLightbox(null)} data-testid="proof-lightbox">
            <button className="absolute top-6 right-6 h-11 w-11 rounded-full bg-white border-2 border-brand-black flex items-center justify-center" aria-label="Close">
              <X size={20} />
            </button>
            <motion.img src={lightbox} alt="Proof" className="max-h-[85vh] max-w-full rounded-2xl border-2 border-white"
              initial={{ scale: 0.9 }} animate={{ scale: 1 }} onClick={(e) => e.stopPropagation()} />
          </motion.div>
        )}
      </AnimatePresence>
    </Section>
  );
}
